import React, { Component } from 'react';
import { Link } from "react-router-dom";
import { inject, observer } from "mobx-react/index";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { formatNullableValue } from '../../../utils/formatar';
import { IconeSetaDireita, IconeSetaDescer, Liberacoes } from '../../comum/components/Icones'
import PopupOpenIcone from '../../comum/components/PopupOpenIcone'
import { Row, Col } from "reactstrap";

@inject("store")
@observer
export default class CardDetalheNotaFiscalFaturament extends Component {
    constructor(props) {
        super(props);
        this.dimensaoColuna = this.props.titulo2 ? 6 : 12;
    }

    renderColuna = (titulo, descricao, formatacao) => {
        let colunaEspecial = (descricao &&
            <div className="desc2">
                {formatacao ?
                    formatNullableValue(formatacao(descricao))
                    :
                    (descricao == 2 ?
                        <div>
                            {descricao[0]}
                            <span className="de-para"> > </span>
                            {descricao[1]}
                        </div>
                        :
                        formatNullableValue(typeof (descricao) === "string" ? descricao : descricao.join(''))
                    )
                }
            </div>);

        if (titulo == "Containers") {
            colunaEspecial = (descricao &&
                <Link to={{
                    pathname: `/containers-detalhes/${descricao}`,
                    state: {
                        codigoContainer: descricao,
                        operacaoBooking: this.props.operacaoBooking
                    }
                }}>{descricao}
                </Link>);
        }

        if (this.props.protocoloId) {
            colunaEspecial = (descricao &&
                <Row className="justify-content-between align-items-center">
                    <Col xl={"auto"} lg={"auto"} md={"auto"}>
                        {descricao}
                    </Col>
                    <Col xl={"auto"} lg={"auto"} md={"auto"} >
                        <a onClick={() => this.props.downloadFile(this.props.protocoloId, this.props.link)}> <Liberacoes /></a>
                    </Col>
                </Row>
            );
        }

        return (
            <Col>
                {descricao && colunaEspecial}
            </Col>);
    }

    render() {
        return (
            <React.Fragment>
                {this.renderColuna(this.props.titulo, this.props.desc, this.props.formatacao)}
            </React.Fragment>
        )
    }
}


// WEBPACK FOOTER //
// ./src/modules/comum/components/CardDetalheNotaFiscalFaturament.js